import React, { useState } from "react";
import SplitPane from "react-split-pane";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { downloadExcel, float, money, success, error } from "@global/actions";
import AJXLoader from "@components/AJXLoader";
import LoadError from "@components/LoadError";
import { apiSend, getRoute, pdfData } from "@services/axios";
import TableHeader from "@components/TableHeader";
import { useTranslation } from "react-i18next";
import IToolbar from "@components/IToolbar";
import { InputGroup, Button, Form, ListGroup, Badge } from "react-bootstrap";
import { confirm } from "@global/actions";
import { useModal } from "@components/ModalRsuiteContext";
 
import { invoiceHeader, invoicetNavItems } from "../configs/module";
const queryClient = new QueryClient();
const Details = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <LoadDetails {...props} />
    </QueryClientProvider>
  );
};

const LoadDetails = (props) => {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);
  const [invoice, setInvoice] = useState({});
  const [rateIds, setRateIds] = useState([]);
  const [initialRateIds, setInitialRateIds] = useState([]);
  const [bookingList, setBookingList] = useState([]);
  const [newBookingList, setNewBookingList] = useState([]);
  const [dataInitial, setDataInitial] = useState([]);
  const paramUseModal = useModal();
  const header = invoiceHeader(t);
  const navItems = invoicetNavItems(t);

  const loadData = async () => {
    window.loader(1);

    const response = await apiSend(
      [getRoute("INVOICE_RETRIEVE"), props.item.id].join("/"),
      "get"
    );
    setInvoice(response?.data?.result);
    setBookingList(response?.data?.result?.bookings);
    setDataInitial(response?.data?.result?.bookings);
    setRateIds(response?.data?.result?.rateIds);
    setInitialRateIds(response?.data?.result?.rateIds);

    setTotal(0);
    window.loader(0);
  };

  const { isLoading, errors } = useQuery("repoData", () => loadData());
  if (isLoading) return <AJXLoader />;
  if (errors) return <LoadError message="invoice not found" />;

  const refresh = async () => {
    await loadData();
  };

  function setMaxAmount() {
    var totalAmount = 0;
    var amount = float(document.getElementById("max-amount").value);
    var data = [];
    var obj = [];
    setRateIds(obj);
    dataInitial.forEach(function (item) {
      totalAmount += float(item.amount);
      if (totalAmount <= amount) {
        data.push(item);
        obj.push(item.rate_id);
      } else {
        totalAmount -= float(item.amount);
      }
    });

    setBookingList(data);
    setRateIds(obj);
  }

  const updateInvoice = async (params) => {
    const response = await apiSend(
      [getRoute("INVOICE_RETRIEVE"), props.item.id, "update"].join("/"),
      "post",
      params
    );

    if (response?.data?.request?.code === 200) {
      success(response?.data?.result?.message);
      await loadData();
    } else {
      error(response?.data?.result?.message);
    }

    paramUseModal.closeModal();
  };
  const save = async () => {
    if (rateIds.length === 0) {
      error(t("the_list_is_empty"));
      return;
    }
    confirm({
      useModal: paramUseModal,
      title: "confirmation",
      params: {
        rateIds: rateIds,
      },
      messageConfirm: t("are_you_sure_to_update_the_invoice"),
      handleChange: updateInvoice,
    });
  };

  const pdf = async (event) => {
    window.wait(1);
    try {
      await pdfData(
        [getRoute("INVOICE_RETRIEVE"), props.item.id, "pdf"].join("/"),
        props.item.invoice_number
      );
    } catch (error) {
      console.log(error);
    }
    window.wait(0);
    success("fin fde téléchargement");
  };

  const excel = async (event) => {
    if (rateIds.length === 0) {
      error(t("the_list_is_empty"));
      return;
    }
    window.wait(1);
    const columnsExcel = [
      { label: "A", width: "25" },
      { label: "B", width: "25" },
      { label: "C", width: "25" },
      { label: "D", width: "25" },
      { label: "E", width: "15" },
      { label: "F", width: "15" },
      { label: "G", width: "5" },
    ];
    const headerExcel = {
      A: "N°",
      B: "service",
      C: "name",
      D: "checkin",
      E: "checkout",
      F: "price",
      G: "",
    };

    let data = [headerExcel];
    var total_excel = 0;
    bookingList.forEach((row) => {
      total_excel += float(row.amount);
      data.push({
        A: row.booking_number,
        B: t(row.service),
        C: row.product_name,
        D: row.checkin,
        E: row.checkout,
        F: row.amount,
        G: row.currency,
      });
    });
    data.push({
      A: "",
      B: "",
      C: "",
      D: "",
      E: "Total",
      F: total_excel,
      G: "",
    });
    var titleName = invoice.invoice_number;
    await downloadExcel("invoice", titleName, data, columnsExcel);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setMaxAmount();
    }
  };

  const searchBookingList = async () => {
    const response = await apiSend(
      [getRoute("INVOICE_SEARCH_BOOKING_NOT_INVOICED")].join("/") +
        "?q=" +
        document.getElementById("input-search-text").value,
      "get"
    );
    setNewBookingList(response?.data?.result);
  };

  const addNewBookingToINvoice = async (rateId) => {
    const response = await apiSend(
      [getRoute("INVOICE_RETRIEVE"), props.item.id, "new/booking", rateId].join(
        "/"
      ),
      "get"
    );

    if (response?.data?.request?.code === 200) {
      success(response?.data?.result?.message);
      refresh();
      searchBookingList();
    } else {
      error(response?.data?.result?.message);
    }
  };

  function ToolBar({ element }) {
    switch (element) {
      case "refresh":
        return (
          <Button className="right-button" onClick={refresh}>
            {t("refresh")}
          </Button>
        );

      case "save":
        return (
          <Button className="right-button" onClick={save}>
            {t("save")}
          </Button>
        );

      case "excel":
        return (
          <Button className="right-button" onClick={excel}>
            {t("Excel")}
          </Button>
        );
      case "pdf":
        return (
          <Button className="right-button" onClick={pdf}>
            {t("Pdf")}
          </Button>
        );
      case "max-amount":
        return (
          <InputGroup size="sm">
            <Form.Control
              className="form-control-input-group"
              type="number"
              id="max-amount"
              defaultValue="0"
              onKeyDown={handleKeyDown}
            />
            <Button
              className="right-button-2"
              onClick={setMaxAmount}
              type="button"
            >
              {t("valider")}
            </Button>
          </InputGroup>
        );

      case "totalinput":
        return (
          <>
            <Form as={"h4"} className="text-right fw-bold p-2">
              {money(total)}
            </Form>
          </>
        );

      default:
        break;
    }
  }

  const NEWListing = () => {
    var dataBody = [];

    newBookingList.forEach(function (item, index) {
      dataBody.push(
        <ListGroup.Item
          as="li"
          id={"rate-id-" + item.rate_id}
          className="d-flex justify-content-between align-items-start"
          key={"rate-" + item.rate_id}
        >
          <div className="ms-2 me-auto">
            <div>
              {" "}
              <small>{item.booking_number}</small>{" "}
            </div>
            <small>
              {money(item.amount)} {item.currency}
            </small>
          </div>

          <Badge
            bg="blue"
            pill
            className="cursor-pointer"
            onClick={() => addNewBookingToINvoice(item.rate_id)}
          >
            +
          </Badge>
        </ListGroup.Item>
      );
    });

    return (
      <ListGroup as="ol" className="mh70vh mt-2">
        {dataBody}
      </ListGroup>
    );
  };

  const Listing = () => {
    var dataBody = [];
    var solde = 0;

    bookingList.forEach(function (item, index) {
      solde += float(item.amount);
      dataBody.push(
        <tr
          id={"rate-" + item.rate_id}
          className="rate-child"
          key={"rate-" + item.rate_id}
        >
          {header.map((head, i) => (
            <td
              key={head.filed + "-" + item.rate_id}
              className="cell100"
              style={{
                width: head.width + "%",
                textAlign: head.align,
              }}
            >
              <Printfiled item={item} filed={head.filed} solde={solde} />
            </td>
          ))}
        </tr>
      );
    });
    setTotal(solde);

    return <>{dataBody}</>;
  };

  return (
    <div>
      <SplitPane
        split="vertical"
        minSize={"20%"}
        maxSize={"20%"}
        defaultSize={"20%"}
      >
        <div className="simulationDiv p-2">
          <InputGroup size="xl">
            <Form.Control
              className="form-control-input-group"
              type="text"
              variant="outline-secondary"
              placeholder={t("search new reservation")}
              id="input-search-text"
              onKeyUp={searchBookingList}
            />
            <Button
              variant="outline-secondary"
              onClick={setMaxAmount}
              type="button"
            >
              {t("OK")}
            </Button>
          </InputGroup>

          <NEWListing />
        </div>
        <div className="statisticsDiv">
          <IToolbar
            navItems={navItems}
            composite={{
              refresh: <ToolBar element="refresh" />,
              save_invoice: <ToolBar element="save" />,
              refresh_max_amount: <ToolBar element="max-amount" />,
              xsl_invoice: <ToolBar element="excel" />,
              pdf_invoice: <ToolBar element="pdf" />,
              totalinvoice: <ToolBar element="totalinput" />,
            }}
            moduleName={t("provider")}
          />
          <div class="tableFixHead">
        
          <table>
              <TableHeader header={header} />
                <tbody>
                  <Listing />
                </tbody>
              </table>
          </div>
        </div>
      </SplitPane>
    </div>
  );
};

export default Details;
const Printfiled = ({ item, filed, solde }) => {
  switch (filed) {
    case "booking_number":
      return <>{item[filed]}</>;
    case "amount":
      return money(item[filed]);
    case "solde":
      return money(solde);
    default:
      return item[filed];
  }
};
